import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Profile from './pages/Profile';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Productos from './pages/Productos';
import Kardex from './pages/Kardex';
import Clientes from './pages/Clientes';
import Ventas from './pages/Ventas';
import Ayuda from './pages/Ayuda';
import Usuarios from './pages/Usuarios';
import { CajaProvider } from './contexts/CajaContext';
import { AuthProvider } from './contexts/AuthContext';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
    background: { default: '#f5f5f5' },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

// ============================================
// COMPONENTES DE PROTECCIÓN DE RUTAS
// ============================================

function PublicRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? <Navigate to="/dashboard" replace /> : children;
}

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (user.rol !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}

// ============================================
// APP ÚNICA - CON CAJAPROVIDER
// ============================================

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    window.location.href = '/login';
  };

  return (
    <AuthProvider>
    <CajaProvider>                              {/* ← ENVUELVE TODO */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route 
              path="/" 
              element={
                isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
              } 
            />
            
            <Route 
              path="/login" 
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } 
            />
            
            <Route path="/reset-password" element={<Login />} />
            
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout onLogout={handleLogout}>
                    <Routes>
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/ventas" element={<Ventas />} />
                      <Route path="/clientes" element={<Clientes />} />
                      <Route path="/perfil" element={<Profile />} />
                      <Route path="/ayuda" element={<Ayuda />} />
                      
                      <Route 
                        path="/productos" 
                        element={
                          <AdminRoute>
                            <Productos />
                          </AdminRoute>
                        } 
                      />
                      <Route 
                        path="/kardex" 
                        element={
                          <AdminRoute>
                            <Kardex />
                          </AdminRoute>
                        } 
                      />
                      <Route 
                        path="/usuarios" 
                        element={
                          <AdminRoute>
                            <Usuarios />
                          </AdminRoute>
                        } 
                      />

                      <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </ThemeProvider>
    </CajaProvider> 
    </AuthProvider>                            
  );
}

export default App;